import createFACTypeData from '@app/state/data/partials/fac_type'
import createFACTypeMembershipsData from '@app/state/data/partials/fac_type_memberships'
import createFACTypeMembershipData from '@app/state/data/partials/fac_type_membership'

const facType = createFACTypeData()
const facTypeMemberships = createFACTypeMembershipsData()
const facTypeMembership = createFACTypeMembershipData()

/**
 * Override the callback for the membership types API
 * 
 * Assigns the answers for the authenticated user (if logged in)
 * Assigns the pricing based on the availabilities selected for the current membership
 * 
 * @param {Object} data API response
 * @returns {Object}
 */
facType.api.callbacks.add(
    'onSuccess',  
    (data, original) => {
        facTypeMemberships.api.parameters.value.fac_type = data?.slug
    }
)

facTypeMemberships.api.callbacks.add(
    'onRequest',  
    (data, original) => {
        const element = document.getElementById('fac-search-header')

        if(element){            
            window.scrollTo({
                top: element.offsetTop,
                left: 0,
                behavior: 'smooth'
            })
        }
    }
)


export function createData(){
    return {
        fac_type             : facType,
        fac_type_memberships : facTypeMemberships,
        fac_type_membership  : facTypeMembership
    }
}